import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-30 overflow-y-auto" }
const _hoisted_2 = { class: "min-h-screen px-4 text-center" }
const _hoisted_3 = ["data-tour"]
const _hoisted_4 = {
  key: 2,
  class: "flex overflow-x-auto items-start text-sm tracking-tight pt-1 -ml-2 mt-4"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mt-6 flex justify-end gap-3" }
const _hoisted_7 = { class: "flex gap-3" }

import { Dialog, DialogDescription, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { computed, ref, watch } from 'vue'


export default {
  __name: 'TheModal',
  props: {
  isOpen: Boolean,
  modalTitle: {
    type: String,
    default: ''
  },
  modalDescription: {
    type: String,
    default: ''
  },
  maxWidth: {
    type: String,
    default: 'max-w-xl'
  },
  tourTarget: {
    type: String,
    default: undefined
  },
  hasTabs: {
    type: Boolean,
    default: false
  },
  footerFullWidth: {
    type: Boolean,
    default: false
  },
  tabs: {
    type: Array,
    default: () => [
      { id: 'main', name: 'Main' },
      { id: 'secondary', name: 'Secondary' }
    ]
  }
},
  emits: ['close-modal'],
  setup(__props, { emit: __emit }) {

const props = __props

const activeTab = ref(props.tabs[0]?.id || 'main')
// Tabs beyond the built-in main/secondary pair render the slot named after their id
const extraTabs = computed(() => props.tabs.filter(tab => !['main', 'secondary'].includes(tab.id)))

// Reset to first tab whenever modal opens
watch(
  () => props.isOpen,
  newValue => {
    if (newValue) {
      activeTab.value = props.tabs[0]?.id || 'main'
    }
  }
)

const emit = __emit

function closeModal() {
  emit('close-modal')
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: props.isOpen,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-black opacity-30" })
                ]),
                _: 1
              }),
              _cache[0] || (_cache[0] = _createElementVNode("span", {
                class: "inline-block h-screen align-middle",
                "aria-hidden": "true"
              }, "​", -1)),
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([props.maxWidth, "inline-block w-full p-6 my-8 text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl"]),
                    "data-tour": props.tourTarget
                  }, [
                    (props.modalTitle)
                      ? (_openBlock(), _createBlock(_unref(DialogTitle), {
                          key: 0,
                          as: "h3",
                          class: "text-lg font-medium leading-6 text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.modalTitle), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (props.modalDescription)
                      ? (_openBlock(), _createBlock(_unref(DialogDescription), {
                          key: 1,
                          class: "text-gray-500 text-sm"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.modalDescription), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (props.hasTabs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (tab) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: tab.id,
                              onClick: $event => (activeTab.value = tab.id),
                              class: _normalizeClass(["flex-shrink-0 px-2 py-1 rounded-md", activeTab.value === tab.id ? 'text-gray-900 font-semibold bg-slate-200' : 'text-gray-600'])
                            }, _toDisplayString(tab.name), 11, _hoisted_5))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass((props.modalTitle || props.modalDescription) && 'mt-4')
                    }, [
                      _withDirectives(_createElementVNode("div", null, [
                        _renderSlot(_ctx.$slots, "main")
                      ], 512), [
                        [_vShow, !props.hasTabs || activeTab.value === 'main']
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _renderSlot(_ctx.$slots, "secondary")
                      ], 512), [
                        [_vShow, props.hasTabs && activeTab.value === 'secondary']
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraTabs.value, (tab) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: tab.id
                        }, [
                          _renderSlot(_ctx.$slots, tab.id)
                        ])), [
                          [_vShow, props.hasTabs && activeTab.value === tab.id]
                        ])
                      }), 128))
                    ], 2),
                    _createElementVNode("div", _hoisted_6, [
                      _withDirectives(_createElementVNode("div", {
                        class: _normalizeClass(["flex gap-3", { 'w-full': props.footerFullWidth }])
                      }, [
                        _renderSlot(_ctx.$slots, "footer")
                      ], 2), [
                        [_vShow, !props.hasTabs || activeTab.value === 'main']
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_7, [
                        _renderSlot(_ctx.$slots, "secondary-footer")
                      ], 512), [
                        [_vShow, props.hasTabs && activeTab.value === 'secondary']
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraTabs.value, (tab) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: `${tab.id}-footer`,
                          class: "flex gap-3"
                        }, [
                          _renderSlot(_ctx.$slots, `${tab.id}-footer`)
                        ])), [
                          [_vShow, props.hasTabs && activeTab.value === tab.id]
                        ])
                      }), 128))
                    ])
                  ], 10, _hoisted_3)
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

}